import { CircularProgress, Typography } from '@mui/material'
import { Outlet, useParams } from 'react-router-dom'

import { ThemeToggle } from '@/components/ThemeToggle'
import { Box } from '@/components/ui'
import { useOrganization } from '@/hooks/useOrganization'

import { OrgSidebar } from './components/OrgSidebar'
import type { OrgRouteContext } from './orgRoute'

export const OrgDetailPage = () => {
  const { orgId } = useParams<{ orgId: string }>()
  const { data: org, isLoading, isError } = useOrganization(orgId ?? '')

  if (!orgId || isLoading) {
    return (
      <Box variant='flexCenter' height='100vh'>
        <CircularProgress />
      </Box>
    )
  }

  if (isError || !org) {
    return (
      <Box variant='flexCenter' height='100vh'>
        <Typography color='text.secondary'>Organization not found.</Typography>
      </Box>
    )
  }

  return (
    <Box variant='fullPage'>
      <OrgSidebar org={org} orgId={orgId} />
      <Box component='main' flex={1} overflow='auto'>
        {/* Handed down rather than re-read per tab: the guards above mean a tab can
            take the organization as given instead of repeating the checks. */}
        <Outlet context={{ org } satisfies OrgRouteContext} />
      </Box>
      <Box position='fixed' bottom={16} right={16} zIndex={1000}>
        <ThemeToggle />
      </Box>
    </Box>
  )
}
